import { Router } from '../router/Router';

/**
 * Header Component.
 */
export class Header {
  /**
   * String of the dom element of the back button.
   *
   * @type {string}
   */
  static backBtnDOMSelector = '#backButton';

  /**
   * Attach back button listener.
   */
  static initBackListener() {
    this.backButtonDOM = document.querySelector(this.backBtnDOMSelector);

    if (this.backButtonDOM) {
      this.backButtonDOM.addEventListener('click', () => {
        Router.back();
      });
    }
  }

  /**
   * Delete Back Button.
   */
  static deleteBackButton() {
    const elem = document.querySelector(this.backBtnDOMSelector);
    if (elem) {
      elem.parentNode.removeChild(elem);
    }
  }
}
